// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__To2OG","list":"BalanceDue_list__n_vD-","listRow":"BalanceDue_listRow__1LSpY","total":"BalanceDue_total__10Kn_"};